import React from "react";
import PropTypes from "prop-types";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyle = makeStyles(theme => ({
  title: {
    padding: theme.spacing(2, 2, 2, 2),
  },
  component: {
    backgroundColor: "#f4f6f8",
    padding: theme.spacing(2, 2, 2, 2),
  },
  container: {
    padding: theme.spacing(1, 1, 1, 1),
  },
}));

const Portfolio = ({ title, component }) => {
  const classes = useStyle();
  return (
    <div className={classes.container}>
      <Paper elevation={3}>
        <div className={classes.title}>
          <Typography variant="h6" id="tableTitle">
            {title}
          </Typography>
        </div>
        <div className={classes.component}>{component}</div>
      </Paper>
    </div>
  );
};

Portfolio.defaultProps = {};

Portfolio.propTypes = {
  component: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
};

export default Portfolio;
